module.exports = __webpack_public_path__ + "static/media/WELAWA_White.29b76fa8.png";